
import BaseLinkedImageButton from '../../../../base/components/sidebar/widgets/LinkedImageButton.vue'

export default class LinkedImageButton extends BaseLinkedImageButton {}
